<template>
  <div class="title">
    <h1>GoogleMap 連携</h1>
    <p>GoogleMapを使って、地図とシステムとの連携が図れます。</p>
    <p>pinをクリックすると、名称と住所を表示します。</p>
    <p>pinを追加したり、デザインを変更することも可能です。</p><br>
    <p>他にもGoogle DriveやGoogle Calendar等の、Googleが提供するサービスとの連携が図れます。</p>
  </div>
  <div class="flexbox">
    <div class="graph">
      <div ref="map" id="map" style="height: 400px"></div>
    </div>
    <div class="graph">
      <div class="table">
        <tr v-if="list.length === 0">
          <td class="empty" style="text-align: left">
            <div class="information">name：</div>
            <div class="information">post code：</div>
            <div class="information">adress：</div>
            <div class="information">telephone：</div>
            <div class="information">URL：</div>
          </td>
        </tr>
        <tr v-for="(item, index) in list" :key="index">
          <td style="text-align: left">
            <div class="information">name：{{ item.title }}</div>
            <div class="information">post code：{{ item.postCode }}</div>
            <div class="information">adress：{{ item.address }}</div>
            <div class="information">telephone：{{ item.telephone }}</div>
            <div class="information">URL：{{ item.url }}</div>
          </td>
        </tr>
      </div>
    </div>
  </div>
  <div class="option">
    <p>開発言語：javascript</p>
    <p>開発言語フレームワーク：vue.js</p>
  </div>
</template>

<script>
export default {
  data: () => ({
    locations: [{
      name: "世田谷公園",
      postCode: "〒154-0023",
      address: "東京都世田谷区池尻１丁目５−２７",
      url: "https://www.city.setagaya.lg.jp/02075/9095.html",
      telephone: "03-3412-××××",
      position: {
        lat: Number(35.6437),
        lng: Number(139.6816),
      },
    },
    {
      name: "駒沢オリンピック公園",
      postCode: "〒152-0021",
      address: "東京都世田谷区駒沢公園1丁目1",
      url: "https://www.tef.or.jp/kopgp/",
      telephone: "03-6380-××××",
      position: {
        lat: Number(35.6251),
        lng: Number(139.6617),
      },
    },
    {
      name: "恵比寿駅",
      postCode: "〒150-0022",
      address: "東京都渋谷区恵比寿南1丁目5-5",
      url: "https://www.jreast.co.jp/estation/stations/290.html",
      telephone: "050-2016-××××",
      position: {
        lat: Number(35.6467),
        lng: Number(139.7101),
      },
    }
    ],
    list: []
  }),
  mounted: function () {
    this.showMap()
  },
  methods: {
    showMap() {
      // APIキーを使用しスクリプトの呼び出す
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDZ3YOwSbs1RGa3tsmNribcEaIaT7rfhpg&callback=initMap';
      script.async = true;
      document.head.appendChild(script);

      // スクリプト呼び出し後のコールバック
      window.initMap = () => {
        const map = new window.google.maps.Map(document.getElementById("map"), {
          zoom: 13,
          center: { lat: 35.638015, lng: 139.685087 },
        });
        this.setMarkers(map);
      };
    },
    setMarkers(map) {
      for (let i = 0; i < this.locations.length; i++) {
        const data = {
          position: { lat: this.locations[i].position.lat, lng: this.locations[i].position.lng },
          map,
          title: this.locations[i].name,
          postCode: this.locations[i].postCode,
          address: this.locations[i].address,
          telephone: this.locations[i].telephone,
          url: this.locations[i].url
        };
        console.log(data)

        const addMarkerClickHandler = (markerData) => {
          markerData.marker.addListener("click", () => {
            this.list = []
            this.list.push(markerData.data);



            console.log(markerData.data.url)
            console.log(this.list)
          });
        };
        addMarkerClickHandler({ marker: new window.google.maps.Marker(data), data });
      }
    },
  }
};
</script>

<style>
#map {
  height: 100%;
}

.content p {
  font-size: 16px;
  padding: 10px;
  margin-bottom: -15px !important;
  margin-top: 0 !important;
  margin-right: 30px;
  margin-left: 30px;
}

.option {
  padding-bottom: 50px;
  padding-top: 20px;
}

@media (max-width: 800px) {
  .title {
    width: 100%;
  }

  #map {
    height: 100%;
    margin: auto;
    width: 350px;
  }

  .graph{
    width: 350px !important;
  }
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.flexbox {
  display: flex;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  width: 1010px;
  margin: 35px auto 0;
}

.graph {
  width: 500px;
  margin: 30px;
}

.table {
  border: solid;
  border-bottom: transparent;
  /* 辺が透明になる */
  border-top: transparent;
  border-right: transparent;
  padding: 20px;
  border-color: #789;
}

th {
  border: solid 1px;
  padding: 10px;
  background-color: #f5f5f5
}

.title {
  margin-bottom: 30px;
}

.information {
  margin-bottom: 5px;
}

@media (max-width: 1170px) {
  .app {
    margin: 50px 0 !important
  }

  .flexbox {
    display: block !important;
    width: 90% !important
  }

  .graph {
    margin: 30px auto !important;
  }
}
</style>